export const listDocumentsAdminService = (fetch) => async () => {
  try {
    const response = await fetch({ url: '/api/v1/documentos-admin' })
    return response
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message)
  }
}
